export default class AsncLib {
  imported() {
    return this.import();
  }
}
